import React from 'react';
import {View} from 'react-native';
import {makeStyles} from '@rn-vui/themed';

import Text from '../../themed/Text';
import SeeAllButton from '../SeeAllButton';

type TitleLineProps = {title?: string; onSeeAllPress?: any};

function TitleLine({title, onSeeAllPress}: TitleLineProps) {
  const styles = useStyles();
  return (
    <View style={styles.containerStyle}>
      <Text noMargin variant="heading1">
        {title}
      </Text>
      {!!onSeeAllPress && <SeeAllButton onPress={onSeeAllPress} />}
    </View>
  );
}

const useStyles = makeStyles(() => {
  return {
    containerStyle: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 12,
    },
  };
});

export default TitleLine;
